"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ChannelEventEmitter", {
  enumerable: true,
  get: function get() {
    return _channelEventEmitter["default"];
  }
});
Object.defineProperty(exports, "TriggerOnceEvents", {
  enumerable: true,
  get: function get() {
    return _triggerOnceEvents["default"];
  }
});

var _channelEventEmitter = _interopRequireDefault(require("./channel-event-emitter"));

var _triggerOnceEvents = _interopRequireDefault(require("./trigger-once-events"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/events/lib/index.js
// module id = 87
// module chunks = 0 1